import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { EdgeLocation } from '@cast/types-omni';

import { getClusterEdgeLocationsQueryKey } from 'hooks/queries/omni/useGetClusterEdgeLocationsQuery';
import { getEdgeConfigurationsQueryKey } from 'hooks/queries/omni/useListEdgeConfigurationsQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const useCreateEdgeLocationMutation = ({
  clusterId,
}: {
  clusterId: string;
}) => {
  const { currentOrganization } = useOrganizations();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (edgeLocation: EdgeLocation) => {
      return apiClient.omni.createEdgeLocation({
        organizationId: currentOrganization!.id,
        clusterId,
        edgeLocation,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getClusterEdgeLocationsQueryKey({ clusterId }),
      });
      queryClient.invalidateQueries({
        queryKey: getEdgeConfigurationsQueryKey({}),
      });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
